export default __webpack_public_path__ + "images/c45c0646693af1f27e5b7b3ba15db84e.svg";